import { MortgageTerms } from '../../api/httpHandlers'
import { InterestRateAppState, AppAction, AppStatus } from '../../appState'
import DebouncedInputs from './DebouncedInputs'
import Result from './Result'

interface Props {
  state: InterestRateAppState
  dispatch: React.Dispatch<AppAction>
  status: AppStatus
  mortgageTerms: MortgageTerms
  blur: boolean
}

export default function FormSection({
  state,
  dispatch,
  status,
  mortgageTerms,
  blur,
}: Readonly<Props>) {
  return (
    <div className="flex flex-col gap-8 md:flex-row">
      <div className="flex w-full max-w-lg flex-1 flex-col gap-6 sm:gap-8">
        <DebouncedInputs interestRateAppDispatch={dispatch} mortgageTerms={mortgageTerms} />
      </div>
      <Result
        status={status}
        interestRateAppDispatch={dispatch}
        interestRateAppState={state}
        blur={blur}
      />
    </div>
  )
}
